import {PATHS} from "../../../../routing/paths";
import {CONTACT, OPERATOR, SERVICE, type LegalDoc} from "./common";

/** Согласие на обработку персональных данных (/consent-pd). */
export const CONSENT_PD_DOC: LegalDoc = {
    title: "Согласие на обработку персональных данных",
    linkLabel: "согласие на обработку персональных данных",
    path: PATHS.consentPd,
    updated: "25 августа 2026 г.",
    sections: [
        {
            title: "1. Общие положения",
            body: [
                `Настоящим я (далее — Пользователь) даю своё свободное, конкретное, информированное и осознанное согласие ${OPERATOR} (далее — Оператор) на обработку моих персональных данных в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».`,
                `Согласие даётся при регистрации в сервисе ${SERVICE} и действует до момента его отзыва.`,
            ],
        },
        {
            title: "2. Состав персональных данных",
            body: [
                "Фамилия, имя, отчество (при указании), дата и место рождения, пол.",
                "Контактные данные: адрес электронной почты, номер телефона.",
                "Фотографии, сведения анкеты, интересы, цели знакомств, город проживания и рождения.",
                "Технические данные: IP-адрес, данные об устройстве, браузере, файлы cookie, геолокация (при явном разрешении).",
            ],
        },
        {
            title: "3. Цели обработки",
            body: [
                "Регистрация и идентификация Пользователя в Сервисе.",
                "Предоставление функций сервиса знакомств: подбор анкет, обмен сообщениями, расчёт совместимости.",
                "Обеспечение безопасности, рассмотрение жалоб и обращений.",
                "Исполнение требований законодательства РФ, в том числе для взаимодействия с Роскомнадзором и иными уполномоченными органами.",
            ],
        },
        {
            title: "4. Способы обработки",
            body: [
                "Обработка персональных данных осуществляется с использованием средств автоматизации, включая сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление и уничтожение.",
                "Персональные данные обрабатываются на серверах, расположенных на территории Российской Федерации.",
            ],
        },
        {
            title: "5. Передача третьим лицам",
            body: [
                "Оператор вправе передавать персональные данные третьим лицам, обеспечивающим работу Сервиса (хостинг, платёжные провайдеры), исключительно в рамках заключённых договоров и с соблюдением мер защиты.",
                "Передача по запросу уполномоченных органов осуществляется в случаях, предусмотренных законодательством РФ.",
            ],
        },
        {
            title: "6. Права субъекта данных",
            body: [
                "Пользователь вправе получить сведения об обрабатываемых данных, потребовать их уточнения, блокирования или уничтожения, а также отозвать настоящее согласие.",
                `Для реализации прав и отзыва согласия направьте обращение на ${CONTACT} или воспользуйтесь разделом «Поддержка».`,
                "Отзыв согласия на обработку персональных данных может привести к невозможности дальнейшего использования Сервиса.",
            ],
        },
    ],
};
